"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _axios = _interopRequireDefault(require("@/utils/axios"));
var _useShopLevel = require("./useShopLevel");
var _tree = require("@ys/utils/lib/tree");
var _antDesignVue = require("ant-design-vue");
const treeSelectProps = _.cloneDeep(_antDesignVue.TreeSelect.props);
// 删除已在当前组件进行重写的属性
delete treeSelectProps.loading;
delete treeSelectProps.searchValue;
delete treeSelectProps.open;
delete treeSelectProps.treeData;
var _default = exports.default = {
  name: 'BasisShopLevelTreeSelect',
  // 店铺层级树选择器组件
  props: {
    ...treeSelectProps,
    // 指定当前选中的条目 必须携带“biz_”或者“shop_”前缀
    value: {
      type: [Array, String],
      default: () => [] // 如 ['biz_1','biz_12391023'] 或 ['shop_9090','shop_8080'] 或 shop_9090
    },
    // 显示清除按钮
    allowClear: {
      type: Boolean,
      default: true
    },
    // 最多显示多少个 tag
    maxTagCount: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String,
      default: '请选择店铺'
    },
    // 在下拉中显示搜索框(仅在单选模式下生效)
    showSearch: {
      type: Boolean,
      default: true
    },
    // 搜索框默认文字
    searchPlaceholder: {
      type: String,
      default: '请输入关键词搜索'
    },
    // 显示 checkbox 默认false
    treeCheckable: {
      type: Boolean,
      default: true
    },
    // 支持多选（当设置 treeCheckable 时自动变为 true）
    multiple: {
      type: Boolean,
      default: false
    },
    // 替换 treeNode 中 title,value,key,children 字段为 treeData 中对应的字段
    // {children:'children', title:'title', key:'key', value: 'value' }
    replaceFields: {
      type: Object,
      default: () => {
        return {
          children: '_children',
          title: '_title',
          value: '_value'
        };
      }
    },
    // 指定默认选中的条目 必须携带“biz_”或者“shop_”前缀
    defaultValue: {
      type: [String, Array],
      default: undefined
    },
    // 默认展开所有树节点 默认值 false
    treeDefaultExpandAll: {
      type: Boolean,
      default: false
    },
    // 默认展开的树节点 string[] | number[] 必须携带“biz_”或者“shop_”前缀
    treeDefaultExpandedKeys: {
      type: Array,
      default: () => ['biz_1']
    },
    // 输入项过滤对应的 treeNode 属性，默认是value
    treeNodeFilterProp: {
      type: String,
      default: '_searchWords'
    },
    // 作为显示的 prop 设置
    treeNodeLabelProp: {
      type: String,
      default: 'title'
    },
    // 定义选中项回填的方式。TreeSelect.SHOW_ALL: 显示所有选中节点(包括父节点). TreeSelect.SHOW_PARENT: 只显示父节点(当父节点下所有子节点都选中时). 默认只显示子节点. TreeSelect.SHOW_CHILD
    showCheckedStrategy: {
      type: String,
      default: 'SHOW_CHILD' // SHOW_ALL / SHOW_PARENT / SHOW_CHILD
    },
    // 自定义属性 - 数据源。如果传递了该值，则会对该值进行数据转换，否则直接通过组件内部方法获取数据
    dataSource: {
      type: Array,
      // 需要严格遵循格式，里面的参数可多不可少：[{bizId:'',bizName:'',children:[{bizId:'',bizName:'',children:[],shops:[]}], shops:[{platformId:'',platformName:'',shopNo:'',shopName:''}]}]
      default: undefined
    },
    // 自定义属性 - 需要新增保留的属性。默认一定会保留“_value,_title,_rawTitle,_children,_hiddenShops,_parentId,disabled,_searchWords”
    filterValidProps: {
      type: [Array, String],
      default: () => [] // all - 表示全量返回，string类型的其他值无效
    },
    // 自定义属性 - 需要过滤掉的店铺shopNo数组。不带“shop_”前缀
    filterOutShopNos: {
      type: Array,
      default: () => [] // 如：['189','9898','6666']
    },
    // 自定义属性 - 是否过滤掉所有店铺仅保留层级，和filterOutAllBizIds不能同时为true，否则直接没有数据
    filterOutAllShopNos: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 需要过滤掉的层级id数组，该层级及其所有下级(包括层级和店铺)均被过滤掉。不带“biz_”前缀
    filterOutBizIds: {
      type: Array,
      default: () => [] // 如：['123','234','132']
    },
    // 自定义属性 - 是否过滤掉所有层级仅保留店铺，和filterOutAllShopNos不能同时为true，否则直接没有数据
    filterOutAllBizIds: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 是否过滤掉没有有效店铺的层级。filterOutAllShopNos为true时该值不生效
    filterOutBizNoShop: {
      type: Boolean,
      default: true
    },
    // 自定义属性 - 禁用的层级id数组，只禁用当前层级，其下级依然有效。不带“biz_”前缀
    disabledBizIds: {
      type: Array,
      default: () => [] // 如：['123','234','132']
    },
    // 自定义属性 - 禁用所有层级id，店铺可以选择
    disabledAllBizIds: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 禁用所有拥有直属子层级且没有直属店铺的层级
    disabledAllNonLeafNodeBizIds: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 禁用的店铺shopNo数组。不带“shop_”前缀
    disabledShopNos: {
      type: Array,
      default: () => [] // 如：['189','9898','6666']
    },
    // 自定义属性 - 隐藏所有的店铺，不在界面展示，但是会在选中的结果中返回。
    // 适用场景：通过点击层级选择店铺但又不需要展示店铺时，把该值设置为true
    hideAllShopNos: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 基于userId禁用层级或过滤店铺
    // 说明：当该属性有值时，将会基于源数据中的users:[{userId,userName}]字段（没有则不做处理），过滤掉没有权限的店铺，禁用没有权限的层级，并过滤掉既没有权限且其下没有有效店铺的层级
    filterByUserId: {
      type: String,
      default: undefined
    },
    // 自定义属性 - 获取店铺层级数据接口链接或者请求方法。默认获取当前登录用户权限范围内的店铺层级结构
    method: {
      type: [String, Function],
      // 获取租户后台最新店铺层级结构 - /v1/biz/level/shop   获取当前登录用户权限范围内的店铺层级结构 - /v1/user/biz/level/shop
      default: '/v1/user/biz/level/shop' // 如 '/v1/user/biz/level/shop' 或 通过api配置的 getLevelShop方法
    },
    // 自定义属性 - 获取店铺层级数据接口参数
    params: {
      type: Object,
      default: () => {}
    },
    // 自定义属性 - 选择框宽度
    width: {
      type: String,
      default: '100%'
    },
    // 自定义属性 - 返回的shops中的shopName是否为原始值 false => xxx百货店（淘宝）  true => xxx百货店
    // 适用场景：一般在需要把真实店铺名称传给接口时把该值设置为true，此时返回的名称不包括平台名称
    returnRawShopName: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 是否默认选中所有节点（层级或店铺），配合 ready 事件使用，在ready后触发业务请求
    defaultSelectedAllNode: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 是否默认选中第一个有效节点（层级或店铺），值为true时，优先级比defaultSelectedFirstShopNo高，配合 ready 事件使用，在ready后触发业务请求
    defaultSelectedFirstNode: {
      type: Boolean,
      default: false
    },
    // 自定义属性 - 是否默认选中第一个有效店铺，一般在单选店铺时使用，配合 ready 事件使用，在ready后触发业务请求
    defaultSelectedFirstShopNo: {
      type: Boolean,
      default: false
    },
    // 是否切换缓存页面时，重刷数据
    reloadByActivated: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      selectedNode: undefined,
      // 当前选中的值，和 props.value 保持一致
      rawData: [],
      // 未经格式转换的原始数据
      transformedData: [],
      // 经过格式转换后的最终用于展示的数据
      searchValue: '',
      // 当前的搜索条件
      searchValueOld: undefined // 上一次的搜索条件，用于选择节点后自动回填到输入框，保证选择框不收起
    };
  },
  computed: {
    // 转换数据的配置参数
    transformOptions() {
      return _.pick(this, ['filterOutShopNos', 'filterOutAllShopNos', 'filterOutBizIds', 'filterOutAllBizIds', 'filterOutBizNoShop', 'disabledBizIds', 'disabledAllBizIds', 'disabledAllNonLeafNodeBizIds', 'disabledShopNos', 'hideAllShopNos', 'filterByUserId', 'filterValidProps', 'treeNodeFilterProp']);
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (!this.defaultValue) this.selectedNode = val || undefined;
        // 清空
        if (_.isEmpty(val) && !_.isEmpty(oldVal)) this.clearSearchValue();
      },
      immediate: true
    },
    selectedNode(val) {
      this.$emit('input', val);
    },
    dataSource: {
      handler(val, oldVal) {
        // 如果没有从外部传值进来，则使用接口获取店铺层级数据
        if (oldVal === undefined && val === undefined) {
          this.getDataList();
        } else if (_.size(val)) {
          this.init(val);
        }
      },
      immediate: true,
      deep: true
    },
    transformedData: {
      // eslint-disable-next-line max-statements
      async handler(val) {
        if (_.size(val)) {
          // 默认值及v-model的值初始化回填
          const initValue = this.defaultValue || this.value;
          if (!_.isEmpty(initValue)) {
            const res = await this.handleChange(initValue, undefined, undefined, false);
            this.$emit('ready', res);
            console.log('ready', res);
            return;
          }
          const {
            defaultSelectedAllNode,
            defaultSelectedFirstNode,
            defaultSelectedFirstShopNo,
            treeCheckable,
            multiple,
            returnRawShopName
          } = this;
          const checked = defaultSelectedAllNode || defaultSelectedFirstNode || defaultSelectedFirstShopNo;
          const isArrayRes = treeCheckable || multiple;
          let value = isArrayRes ? [] : undefined;
          let label = isArrayRes ? [] : undefined;
          let extra = void 0;
          if (checked) {
            // 第一个有效节点：可能是层级或店铺
            const firstValidNode = (0, _tree.findNode)(val, node => node.disabled !== true, _useShopLevel.treeConfig) || val[0];
            // 第一个有效店铺节点
            const firstValidShopNode = (0, _tree.findNode)(val, node => node.disabled !== true && !node._isBiz, _useShopLevel.treeConfig) || {};
            // eslint-disable-next-line no-nested-ternary
            const dataRef = defaultSelectedAllNode ? val[0] : defaultSelectedFirstNode ? firstValidNode : defaultSelectedFirstShopNo ? firstValidShopNode : {};
            extra = {
              checked,
              triggerNode: {
                dataRef
              }
            };
            const {
              _value,
              _title,
              _rawTitle
            } = dataRef;
            const targetTitle = returnRawShopName ? _rawTitle : _title;
            value = isArrayRes ? [_value] : _value;
            label = isArrayRes ? [targetTitle] : targetTitle;
          }
          const res = await this.handleChange(value, label, extra, false);
          this.$emit('ready', res);
          console.log('ready', res);
        }
      },
      immediate: true,
      deep: true
    },
    searchValue: {
      handler(newVal, oldVal) {
        // 清空输入框时才更新
        if (!newVal && oldVal && this.searchValueOld !== oldVal) this.searchValueOld = oldVal;
      },
      immediate: true
    }
  },
  activated() {
    // 为了从其他页面切换回来当前页加载最新数据，确保数据的实时性
    if (this.reloadByActivated) {
      this.reload(true);
    }
  },
  methods: {
    // 清空搜索词 - 供外部使用，勿修改命名
    clearSearchValue() {
      this.searchValue = null;
      this.searchValueOld = null;
    },
    /**
     * @description: 供外部组件手动调用更新数据，勿修改命名
     * @param {boolean} force 如果为true，强制重新请求接口
     */
    reload(force) {
      // 避免同时存在多个请求
      if (this.loading) return;
      this.selectedNode = undefined;
      this.transformedData = [];

      // nextTick 确保selectedNode和transformedData已经清空完毕，且界面已经更新，否则会出现输入框文字错乱的问题
      this.$nextTick(() => {
        const {
          dataSource,
          rawData
        } = this;
        // 如果没有从外部传值进来，优先使用本地已存在的原始数据，否则使用接口获取店铺层级数据或者
        if (dataSource === undefined) {
          if (rawData.length > 0 && !force) {
            this.init(rawData);
          } else {
            this.getDataList();
          }
        } else if (Array.isArray(dataSource)) {
          this.init(dataSource);
        }
      });
    },
    // 获取店铺层级数据
    async getDataList() {
      try {
        this.loading = true;
        const res = typeof this.method === 'function' ? await this.method(this.params) : await _axios.default.get(this.method, this.params);
        this.init(res);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    async init(rawData) {
      try {
        this.loading = true;
        this.rawData = _.cloneDeep(rawData);
        this.transformedData = await (0, _useShopLevel.transformRawData)(rawData, this.transformOptions);
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    // 自定义搜索逻辑
    handleFilterTreeNode(inputValue, treeNode) {
      const _searchWords = treeNode.data.props[this.treeNodeFilterProp];
      return _searchWords && _searchWords.indexOf(inputValue.trim()) > -1;
    },
    /**
     * 选中树节点时调用此函数 function(value, label, extra)
     * @param {object} params
     * @param {string|array} params.value treeCheckable为true时value为数组、否则为字符串。节点对应的value值，会带有“biz_”或“shop_”前缀
     * @param {array} params.label 节点对应显示的标题
     * @param {object} params.extra {preValue:[],selected:true（treeCheckable为false时才有该参数），allCheckedNodes:[选中的节点]（treeCheckable为true时才有该参数）,triggerNode:{} //实际应用中可通过 triggerNode.dataRef 获取当前选择的节点及其所有下级,triggerValue:''}
     * @param {boolean} params.triggerEmit 是否触发this.$emit('change', res)事件
     */
    // eslint-disable-next-line max-statements
    async handleChange(value, label, extra, triggerEmit = true) {
      // 只传了value，没传label的情况=》父组件传入defaultValue或v-model作为默认值手动调用方法
      // 自动补全label
      if (value && !label) {
        const {
          transformedData,
          returnRawShopName
        } = this;
        if (Array.isArray(value)) {
          // 多选
          const arr = (0, _tree.findNodeAll)(transformedData, node => value.includes(node._value), _useShopLevel.treeConfig);
          const tempValue = arr.map(item => item._value);
          const tempLabel = arr.map(item => returnRawShopName ? item._rawTitle : item._title);

          // 当前用户没有相关店铺的权限了，店铺不在原始数据中
          const xorValues = _.xorBy(tempValue, value);
          value = [...tempValue, ...xorValues];
          label = [...tempLabel, ...xorValues];
        } else {
          // 单选
          const targetNode = (0, _tree.findNode)(transformedData, node => value === node._value, _useShopLevel.treeConfig);
          if (targetNode) {
            value = targetNode._value;
            label = returnRawShopName ? targetNode._rawTitle : targetNode._title;
          }
        }
      }
      let res = {
        value,
        label,
        extra
      };

      // treeCheckable 或 multiple 为 true 时 value 返回数组，否则返回字符串
      if (Array.isArray(value)) {
        const bizIds = [];
        const bizList = [];
        const shopNos = [];
        const shops = [];

        // 处理选中的结果
        const {
          value: targetValues = [],
          label: targetLabels = [],
          dataRef
        } = await this.getTargetValue(value, label, extra);
        targetValues.forEach((item, index) => {
          const realValue = (0, _useShopLevel.getRealValue)(item);
          if ((0, _useShopLevel.isBiz)(item)) {
            bizIds.push(realValue);
            bizList.push({
              bizId: realValue,
              bizName: targetLabels[index]
            });
          } else {
            shopNos.push(realValue);
            shops.push({
              shopNo: realValue,
              shopName: targetLabels[index]
            });
          }
        });
        // 返回的数据改成了对象，可通过对象解构进行获取
        // 比官方文档扩充返回参数：bizIds, bizList, shopNos, shops
        res = {
          value: targetValues,
          label: targetLabels,
          extra,
          dataRef,
          bizIds,
          bizList,
          shopNos,
          shops
        };

        // 更新最终选中的节点
        this.selectedNode = targetValues;
      } else {
        const dataRef = extra?.triggerNode?.dataRef;
        const {
          bizIds,
          bizList,
          shopNos,
          shops
        } = (0, _useShopLevel.getAllBizShop)(dataRef, this.returnRawShopName);
        const {
          directlyBiz,
          directlyShopNos,
          directlyShops,
          directlyBizShopMap
        } = (0, _useShopLevel.getDirectlyBizShop)(dataRef, this.returnRawShopName);

        // 返回的数据改成了对象，可通过对象解构进行获取
        // 除了value, label, extra三个官方文档返回的字段外，其余均为扩展字段，根据实际业务需要使用
        res = {
          value: (0, _useShopLevel.getRealValue)(value),
          // 把真实的值返回，减少实际业务中的数据转换过程,
          label: label?.toString(),
          extra,
          dataRef,
          bizIds,
          bizList,
          shopNos,
          shops,
          isBiz: (0, _useShopLevel.isBiz)(value),
          directlyBiz,
          directlyShopNos,
          directlyShops,
          directlyBizShopMap
        };
        this.selectedNode = value;
      }
      if (triggerEmit) {
        this.$emit('change', res);
        console.log('change', res);
      }
      return res;
    },
    // 文本框值变化时回调 function(value: string)
    handleSearch(value) {
      this.$emit('search', value);
    },
    // 展开节点时调用 function(expandedKeys)
    handleTreeExpand(expandedKeys) {
      this.$emit('treeExpand', expandedKeys);
    },
    // 获得焦点
    handleBlur() {
      // 收起后再打开，清空旧值，相当于重新开始
      this.searchValueOld = this.searchValue;
    },
    /**
     * @description: 多选时获取最终的有效结果：全选或取消全选等选择操作仅对符合搜索条件的数据起作用。所见即所得！
     * @param {array} value change事件的value
     * @param {array} label change事件的label
     * @param {object} extra change事件的extra
     * @return {object} {value,label,extra,dataRef}
     */
    getTargetValue(value, label, extra = {}) {
      return new Promise(resolve => {
        // eslint-disable-next-line max-statements, complexity
        this.$nextTick(() => {
          // preValue = [{label,value}]
          const {
            triggerNode = {},
            checked,
            preValue = [],
            triggerValue = ''
          } = extra;
          const dataRef = triggerNode?.dataRef || triggerNode?.data?.props?.dataRef; // 当前点击的节点

          const {
            showCheckedStrategy
          } = this;
          // dataRef没传表示通过defaultValue触发change事件
          // showCheckedStrategy === 'SHOW_PARENT' =》 直接返回change事件原始值
          if (_.isEmpty(dataRef) || showCheckedStrategy === 'SHOW_PARENT') {
            resolve({
              value,
              label: label || value,
              extra,
              dataRef
            });
            return;
          }
          let targetValues = []; // 最终的value数组
          let targetLabels = []; // 最终的label数组
          let targetChecked = checked;

          // 操作类型
          let action = targetChecked ? 'checked' : 'unchecked';
          const extraKeys = Object.keys(extra);
          if (extraKeys.length === 1 && extraKeys[0] === 'preValue') action = 'allClear'; // 点击输入框右边的清空按钮
          if (extraKeys.length > 1 && targetChecked === undefined) action = 'singleClear'; // 点击输入框中某一个tag的删除按钮

          // action === 'singleClear' && !searchValue => 表示用户已主动清空了搜索内容
          // action === 'unchecked' && value.length === 0 => 仅已选中一个，且被取消选中，需清空搜索历史，否则导致无法勾选其他选项
          if (action === 'allClear' || action === 'singleClear' && !this.searchValue || action === 'unchecked' && value.length === 0) {
            this.clearSearchValue();
          }
          const {
            searchValue,
            searchValueOld,
            returnRawShopName
          } = this;
          if (action !== 'allClear' && value.length > 0) {
            // FIXME: 在下拉选择框展开时，搜索关键词从有到无时，无法选择一个不包含之前的关键词层级或店铺
            // 解决方案：判断是用户主动把searchValue清空的，此时把searchValueOld也设置为空。目前存在的问题是无法判断是否为用户主动通过回退键清空
            const targetSearchValue = searchValue || searchValueOld;

            // 回填searchValue，确保页面停留在搜索结果页
            this.searchValue = targetSearchValue;
            const preValues = preValue.map(item => item.value);
            const preLabels = preValue.map(item => item.label);

            // 当前选中节点下的所有子节点
            let curShopValues = [];
            let curShopLabels = [];
            let curBizValues = [];
            let curBizLabels = [];

            // 当前选中节点的所有上级父节点
            const parentBizValues = [];
            const parentBizLabels = [];
            if (dataRef) {
              // action === 'singleClear' ? null : targetSearchValue => 输入框中删除单个tag，且该tag不在当前搜索条件内
              const {
                shops: curCheckedShops,
                bizList: curCheckedBizList
              } = (0, _useShopLevel.getAllBizShop)(dataRef, returnRawShopName, action === 'singleClear' ? null : targetSearchValue);

              // 取消某节点，把该节点的所有父节点都取消
              if (showCheckedStrategy === 'SHOW_ALL' && !targetChecked) {
                const nodes = (0, _tree.findPath)(this.transformedData, node => node._value === dataRef._value, _useShopLevel.treeConfig);
                nodes.map(node => {
                  parentBizValues.push(node._value);
                  parentBizLabels.push({
                    bizId: node._value,
                    bizName: returnRawShopName ? node._rawRitle : node._title
                  });
                });
              }
              curShopValues = curCheckedShops.map(item => `shop_${item.shopNo}`);
              curShopLabels = curCheckedShops.map(item => item.shopName);
              curBizValues = curCheckedBizList.map(item => `biz_${item.bizId}`);
              curBizLabels = curCheckedBizList.map(item => item.bizName);

              // searchValue有值时，通过点击层级父节点（部分选择状态）取消该父节点下符合搜索条件的数据
              if (targetSearchValue && (0, _useShopLevel.isBiz)(triggerValue)) {
                const inter = _.intersection(preValues, curShopValues);
                if (inter.length === curShopValues.length) targetChecked = false;
              }
            }
            // _.pullAll 删除数组中元素
            targetValues = targetChecked ? _.uniq([...preValues, ...curShopValues, ...curBizValues]) : _.pullAll(preValues, [...curShopValues, ...curBizValues, ...parentBizValues]);
            targetLabels = targetChecked ? _.uniq([...preLabels, ...curShopLabels, ...curBizLabels]) : _.pullAll(preLabels, [...curShopLabels, ...curBizLabels, ...parentBizLabels]);
          }
          resolve({
            value: targetValues,
            label: targetLabels,
            extra,
            dataRef
          });
        });
      });
    }
  }
};